import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { InventoryRequestEmailEditTemplate } from 'themes/application/inventory-request/pages';
import { InventoryRequestEmailEditViewStore } from 'application/inventory-request/stores';

@setCurrentView((rootStore) => new InventoryRequestEmailEditViewStore(rootStore), 'inventoryRequestEmailEditViewStore')
@observer
class InventoryRequestEmailEdit extends React.Component {
    render() {
        return <InventoryRequestEmailEditTemplate {...this.props} />
    }
}

export default InventoryRequestEmailEdit;
